module.exports = __webpack_public_path__ + "Roboto-Bold.c7f4667b59b9bc95130e.svg";


//////////////////
// WEBPACK FOOTER
// ./~/roboto-fontface/fonts/Roboto/Roboto-Bold.svg
// module id = 269
// module chunks = 19